import reframe from 'nike-re-framejs';
import { defaultMiddlewares } from '@/common/util';
import { loadHelpArticles } from './api';

reframe.registerHandler('helpArticles.load', defaultMiddlewares, db => {
    if (!db.getIn(['cms', 'sections', 'help'])) {
        loadHelpArticles();
    }
    return db;
});
